// Copyright (c) StrangeBee 2023

import { ICONS } from '@Constants/iconsApp';
import { Spin } from 'antd';
import React, { ReactElement } from 'react';

import './DisplayLoading.scss';

interface DisplayLoadingProps {
    isLoading: boolean;
    count: number;
}

const DisplayLoading = ({ isLoading, count }: DisplayLoadingProps): ReactElement => {
    return (
        <div className="display-loading">
            {isLoading && <Spin indicator={<ICONS.LoadingIcon />} />}{' '}
            {!!count && <div className="display-loading__count">{count}</div>}
        </div>
    );
};

export default DisplayLoading;
